import logo from "./logo.svg";
import { HashRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Landing/Index";
import Login from "./pages/Landing/Login";
import ForgotPassword from "./pages/Landing/ForgotPassword";
import Offer from "./pages/Landing/Offer";
import Agency from "./pages/Landing/Agency";
import "./assets/css/setup.css";
import "./assets/css/style.css";
import "./assets/css/mentionLegal.css";
import Candidate from "./pages/Landing/Candidate";
import CandidateTracking from "./pages/Agency/CandidateTracking";
import MissionDetail from "./pages/Global/MissionDetail";
import MissionDetailEntreprise from "./pages/Global/MissionDetailEntreprise";
import MissionList from "./pages/Interim/MissionList";
import Dashboard from "./pages/Agency/Dashboard";
import InternProfile from "./pages/Agency/InternProfile";
import MissionAccepted from "./pages/Interim/MissionAccepted";
import Salary from "./pages/Interim/Salary";
import EditProfile from "./pages/Global/EditProfile";
import EditProfilePage from "./pages/Global/EditProfile";
import DashboardInterim from "./pages/Interim/Dashboard-Interim";
import AgencyDetail from "./pages/Interim/AgencyDetail";
import SyntheseFinancierePage from "./pages/Agency/SyntheseFinancierePage";
import JobOffers from "./pages/Interim/JobOffers";
import InterimResearch from "./pages/Interim/InterimResearch";
import MissionCreation from "./pages/Agency/MissionCreation";
import ReleveHeure from "./pages/Agency/TimesheetPage";
import AgencyInterim from "./pages/Interim/AgencyList";
import AgencyList from "./pages/Agency/AgencyList";
import Calendar from "./pages/Global/Calendar";
import MissionListAgency from "./pages/Agency/MissionList";
import MentionLegal from "./pages/Landing/MentionLegal";

import ContractListPage from "./pages/Global/ContractListPage";
import EditProfileCompanyPage from "./pages/Agency/EditprofileAgency";
import CalendarEntreprise from "./pages/Global/CalendarEntreprise";
import ContractListPageEntreprise from "./pages/Global/ContractListPageEntreprise";
// import "./assets/css/responsive.css";

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/candidature" element={<Candidate />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgotPassword" element={<ForgotPassword />} />
        <Route path="/offer" element={<Offer />} />
        <Route path="/agency" element={<Agency />} />
        <Route path="/candidate-tracking" element={<CandidateTracking />} />
        <Route path="/mission-detail" element={<MissionDetail />} />
        <Route
          path="/mission-detail-entreprise"
          element={<MissionDetailEntreprise />}
        />
        <Route path="/mission-list" element={<MissionList />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/intern-profile" element={<InternProfile />} />
        <Route path="/mission-accepted" element={<MissionAccepted />} />
        <Route path="/salary" element={<Salary />} />
        <Route path="/edit-profile" element={<EditProfilePage />} />
        <Route
          path="/edit-profile-company"
          element={<EditProfileCompanyPage />}
        />
        <Route path="/dashboard-interim" element={<DashboardInterim />} />
        <Route path="/agency-detail" element={<AgencyDetail />} />
        <Route
          path="/synthese-financiere"
          element={<SyntheseFinancierePage />}
        />
        <Route path="/job-offer" element={<JobOffers />} />
        <Route path="/interim-research" element={<InterimResearch />} />
        <Route path="/mission-creation" element={<MissionCreation />} />
        <Route path="/releve-heure" element={<ReleveHeure />} />
        <Route path="/contract-list" element={<ContractListPage />} />
        <Route
          path="/contract-list-entreprise"
          element={<ContractListPageEntreprise />}
        />
        <Route path="/interim/listAgency" element={<AgencyInterim />} />
        <Route path="/agency/listAgency" element={<AgencyList />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/calendar-entreprise" element={<CalendarEntreprise />} />
        <Route path="/mission-list-agency" element={<MissionListAgency />} />
        <Route path="/mentions-legal" element={<MentionLegal />} />
        {/* <Route path="/mentions-legal" element={<MentionLegal />} />
        <Route path="/politique-de-confidentialite" element={<Politique />} /> */}
      </Routes>
    </HashRouter>
  );
}

export default App;
